import Description from "../components/Description"
//file renders description single product
const DescriptionPage = () => {
    return (
        <div>
            <Description />
        </div>
    )
}

export default DescriptionPage
